/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {

  if (!window.location.pathname.includes("/blogs/")) return;

  const article = document.querySelector(".article__content");
  if (!article) return;

  const faqHeading = Array.from(article.querySelectorAll("h2"))
    .find(h => h.textContent.toLowerCase().includes("الاسئلة"));

  if (!faqHeading) return;

  let current = faqHeading.nextElementSibling;
  let questions = [];

  while (current) {

    if (current.tagName === "H2") break;

    if (current.tagName === "H3") {

      const question = current.textContent.trim();

      let answer = "";
      let next = current.nextElementSibling;

      while (next && next.tagName !== "H3" && next.tagName !== "H2") {
        answer += next.textContent.replace(/\s+/g, " ").trim() + " ";
        next = next.nextElementSibling;
      }

      if (question && answer) {
        questions.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answer.trim()
          }
        });
      }
    }

    current = current.nextElementSibling;
  }

  if (!questions.length) return;

  const oldSchema = document.querySelector("#auto-faq-schema");
  if (oldSchema) oldSchema.remove();

  const script = document.createElement("script");
  script.id = "auto-faq-schema";
  script.type = "application/ld+json";

  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions
  });

  document.head.appendChild(script);

});
